// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/icon/iconfont.css'
// import VueQuillEditor from 'vue-quill-editor'
// Vue.use(VueQuillEditor);
// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
import moment from 'moment'// 导入文件
Vue.prototype.$moment = moment // 赋值使用
moment.locale('zh-cn') // 需要汉化
Vue.config.productionTip = false
Vue.use(ElementUI)

/* eslint-disable no-new */
Vue.filter('fixed', function (value) {
  if (!value) value = 0
  return Number(value).toFixed(2)
})


new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js